import { render } from "./TriageSelect.vue?vue&type=template&id=fb7bb720&scoped=true&ts=true"
import script from "./TriageSelect.vue?vue&type=script&lang=ts"
export * from "./TriageSelect.vue?vue&type=script&lang=ts"

import "./TriageSelect.vue?vue&type=style&index=0&id=fb7bb720&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7bb720"]])

export default __exports__